export function curveLineOptions() {
  return {
    scales: {},
    elements: {
      line: {
        tension: 0.3,
      },
    },
    plugins: {
      legend: {
        display: true,
      },
      title: {
        text: "",
        display: true,
      },
    },
  };
}

export function horizontalChartOptions() {
  return {
    indexAxis: "y" as const,
    scale: {
      y: {
        ticks: {
          autoSkip: false,
          maxTicksLimit: 1000,
          minRotation: 0,
          maxRotation: 0,
        },
        adapters: {
          date: {
            locale: "hr",
          },
        },
        type: "time",
        time: {
          unit: "month",
        },
      },
    },
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        position: "right" as const,
        display: true
      },
      title: {
        text: "",
        display: false,
      },
    },
  };
}
